export enum SavedViewsBlock {
  Root = 'SavedViews',
}
